/**
 * White-label scrubber — removes any third-party branding injected
 * into the document by the hosting platform (badge, title, description,
 * analytics scripts) at runtime.
 *
 * Runs as soon as the React tree mounts, plus a MutationObserver to
 * keep the page clean if any element gets re-injected after load.
 */

const BAD_TITLE_TOKENS = ["Emergent | Fullstack App", "Emergent |"];
const BAD_DESC_TOKENS = ["emergent.sh", "Made with Emergent"];
const BAD_BADGE_SELECTORS = [
  "#emergent-badge",
  'a[href*="emergent.sh"]',
  'iframe[src*="emergent.sh"]',
  'iframe[src*="cdn-cgi/challenge"]',
  '[data-emergent-badge]',
];
const BAD_SCRIPT_TOKENS = [
  "assets.emergent.sh",
  "ap.emergent.sh",
  "posthog.init",
];

function removeBadgeElements(root = document) {
  for (const sel of BAD_BADGE_SELECTORS) {
    root.querySelectorAll(sel).forEach((el) => {
      try { el.remove(); } catch { /* swallow */ }
    });
  }
}

function removeBadDescriptionMetas() {
  document.querySelectorAll('meta[name="description"]').forEach((m) => {
    const c = (m.getAttribute("content") || "").toLowerCase();
    if (BAD_DESC_TOKENS.some((t) => c.includes(t.toLowerCase()))) {
      try { m.remove(); } catch { /* swallow */ }
    }
  });
}

function fixBadTitleOnce() {
  // If react-helmet hasn't set the title yet, force a clean default so the
  // user never sees "Emergent | Fullstack App" in the tab during the FOUC.
  const t = document.title || "";
  if (BAD_TITLE_TOKENS.some((b) => t.includes(b))) {
    document.title = "UID Infotech";
  }
}

function removeBadScripts() {
  document.querySelectorAll("script[src]").forEach((s) => {
    const src = s.getAttribute("src") || "";
    if (BAD_SCRIPT_TOKENS.some((tok) => src.includes(tok))) {
      try { s.remove(); } catch { /* swallow */ }
    }
  });
}

function injectGuardCss() {
  if (document.getElementById("uid-whitelabel-css")) return;
  const style = document.createElement("style");
  style.id = "uid-whitelabel-css";
  style.textContent = `
    #emergent-badge,
    a[href*="emergent.sh"],
    iframe[src*="emergent.sh"],
    [class*="emergent-badge"],
    [data-emergent-badge] {
      display: none !important;
      visibility: hidden !important;
      opacity: 0 !important;
      pointer-events: none !important;
      width: 0 !important;
      height: 0 !important;
      position: absolute !important;
      left: -9999px !important;
      top: -9999px !important;
    }
  `;
  document.head.appendChild(style);
}

let observer = null;

export function startWhiteLabelScrubber() {
  if (typeof window === "undefined" || typeof document === "undefined") return;
  // Run once immediately
  injectGuardCss();
  fixBadTitleOnce();
  removeBadDescriptionMetas();
  removeBadgeElements();
  removeBadScripts();

  // Keep scrubbing if anything gets re-injected (badge sometimes loads after main JS)
  if (observer) return;
  observer = new MutationObserver(() => {
    removeBadgeElements();
    removeBadDescriptionMetas();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  // Also re-scrub a few times in the first second for safety (covers async badge inject)
  let n = 0;
  const t = setInterval(() => {
    removeBadgeElements();
    removeBadDescriptionMetas();
    n += 1;
    if (n >= 10) clearInterval(t);
  }, 100);
}

export function stopWhiteLabelScrubber() {
  if (observer) {
    observer.disconnect();
    observer = null;
  }
}
